// extracted by mini-css-extract-plugin
export default {"app__outer":"App_app__outer__tzZzD"};